import script from "./PlanTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanTable.vue?vue&type=script&setup=true&lang=ts"

import "./PlanTable.vue?vue&type=style&index=0&id=f43b214c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f43b214c"]])

export default __exports__